import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Card, CardContent, CardHeader, Divider,
  Typography, Box, Paper, ButtonBase, makeStyles
} from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2)
  },
  card: {
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
  },
  content: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default
  },
  downloadArea: {
    width: '100%',
    borderRadius: 8,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    backgroundColor: theme.palette.background.paper,
    border: `1px dashed ${theme.palette.divider}`,
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.action.hover,
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 12px rgba(0,0,0,0.1)'
    }
  },
  innerBox: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: '100%',
    textAlign: 'left'
  },
  pdfIcon: {
    fontSize: 48,
    color: '#e74c3c', // PDF Kırmızısı
    marginRight: theme.spacing(2)
  },
  downloadIcon: {
    marginLeft: 'auto',
    color: theme.palette.text.secondary
  }
}));

function SalesKatalog({ className, ...rest }) {
  const classes = useStyles();

  const handleOpenPdf = () => {
    const pdfPath = `${process.env.PUBLIC_URL}/pdf/quick_shine_katalog.pdf`;
    window.open(pdfPath, '_blank');
  };

  if (!window.navigator.onLine) return null;

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Card className={classes.card}>
        <CardHeader 
          title={
            <Typography variant="h6" color="textPrimary" style={{ fontWeight: 600 }}>
              Quick & Shine Katalog
            </Typography>
          } 
          subheader="Teknik doküman ve ürün detayları"
        />
        <Divider />
        <CardContent className={classes.content}>
          <ButtonBase 
            className={classes.downloadArea} 
            onClick={handleOpenPdf}
            component={Paper}
            elevation={0}
          >
            <Box className={classes.innerBox}>
              <PictureAsPdfIcon className={classes.pdfIcon} />
              <Box>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                  Quick & Shine Kataloğu.pdf
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  Dosyayı yeni sekmede görüntülemek için tıklayın
                </Typography>
              </Box>
              <GetAppIcon className={classes.downloadIcon} fontSize="small" />
            </Box>
          </ButtonBase>
        </CardContent>
      </Card>
    </div>
  );
}

SalesKatalog.propTypes = {
  className: PropTypes.string
};

export default SalesKatalog;